import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	repositoryLabel: {
		id: 'dynamic-cards-search-page.search-result.repository-label',
		defaultMessage: 'Repository',
		description: 'Repository metadata label',
	},
});
